import SecureLS from "secure-ls";
import createPersistedState from "vuex-persistedstate";
let k='376E5581FA65F';
/*
import {debounce} from "../lib/rate";
import SlicedPersistenceHandler from "../lib/slicePersistor";

//Add all excluded mutations here
const excludeMutations = [

];

const moduleSettings = {
  language: {persist: true, secure:false},
  auth: {persist: true, secure:true},
  textassets: {persist: false, secure:false},
  assets: {persist: false, secure:true},
  person: {persist: false, secure:true},
  media: {persist: false},
  drawer: {persist: false},
  assessment: {persist: false},
  journey: {persist: false},
};
*/
const ls = new SecureLS({ isCompression: false, encodingType: 'rabbit', encryptionSecret:k});
//const handler = new SlicedPersistenceHandler(ls, moduleSettings,excludeMutations);
/*
export default createPersistedState({
  key: 'fitt',
  filter: (mutation)=>handler.filter(mutation),
  getState: (key)=>handler.getState(key),
  setState: debounce((key, state)=>{
    handler.setState(key, state);
  },500),
});
*/
export default createPersistedState({
  key: 'fitt2',
  paths: ['auth','locale','assessment.answerBuffer','assessment.answerBufferInFlight',
          'assessment.auditLogBuffer','assessment.auditLogInFlight',
          'media.cameraDevice','media.audioOutputDevice','media.audioInputDevice','media.volume',
          'speedtest.lastRunAt','speedtest.passed','speedtest.uploadSpeed','speedtest.downloadSpeed'
  ],
  filter: (mutation)=>{
    const answerBufferMutations=[
      'addAnswerToBuffer',
      'convertAnswerBufferToInFlight',
      'clearAnswerBuffer',
      'clearInFlightBuffer',
      'addToAuditLogBuffer',
      'clearAuditLogBuffer',
      'convertAuditLogBufferToInFlight',
      'clearInFlightAuditLogBuffer'
    ];
    if(answerBufferMutations.includes(mutation.type.replace('assessment/',''))){
      return true;
    }
    const mediaMutations=['setCameraDevice',
      'setAudioOutputDevice',
      'setAudioInputDevice',
      'setVolume',
    ];
    if(mediaMutations.includes(mutation.type.replace('media/',''))){
      return true;
    }
    return mutation.type.includes('auth/') || mutation.type.includes('locale/') || mutation.type.includes('speedtest/');
  },
  storage: {
    getItem: key => ls.get(key),
    setItem: (key, value) => ls.set(key, value),
    removeItem: key => ls.remove(key)
  }
});

